export const SUBSCRIPTION_PRODUCT_NAMES: Record<string, string> = {
    'IMAGO-S': 'Imago Standard',
    'IMAGO-E': 'Imago Enterprise',
    'IMAGO-J': 'Imago Junior',
    'IMAGO-CAPACITY-UNITS': 'Seequent Monthly Capacity Units',
    'IMAGO-S-H': 'Imago Standard Hibernation',
    'IMAGO-E-H': 'Imago Enterprise Hibernation',
    'IMAGO-J-H': 'Imago Junior Hibernation',
    'EXTRA-STORAGE': 'Imago Extra Storage - 1 TB/Workspace - Subscription',
    'MOBILE-CAPTURE': 'Imago Mobile Capture - Subscription',
    'IMAGO-EAP': 'Imago Early Access Programme',
    'IMAGO-DATA-SHARING': 'Imago Data Sharing',
    'CAPTURE-CHIP': 'Imago Capture - Chip Shot - Subscription',
    'CAPTURE-CORE': 'Imago Capture - Core Shot - Subscription',
};
